import React, { useState, useContext } from "react";
import Step1 from "../components/NewList/Step1";
import Step2 from "../components/NewList/Step2";
import ModelsModal from "../components/NewPedigree/ModelsModal";
import useSourAlert from "../hooks/useSourAlert";
import SourAlert from "../components/elements/SourAlert";

import MainStructure from "../components/containers/MainStructure";
import { useNavigate } from "react-router-dom";
import { horseListService } from "../api";

function NewList() {
	const navigate = useNavigate();

	const [isOpenModels, setIsOpenModels] = useState(false);

	const [pedigreeData, setPedigreeData] = useState({ type: "sire" });
	const [alertProps, showAlert] = useSourAlert();

	const handleStep1Change = (newData) => {
		setPedigreeData((prev) => ({ ...prev, ...newData }));
	};

	function handleReportClick() {
		horseListService
			.create(pedigreeData)
			.then(() => {
				navigate("/my-lists");
			})
			.catch((error) => {
				console.error("Error generating report:", error);
				let description =
					"An error occurred while generating the report. Please try again.";

				if (error && typeof error === "object") {
					const messages = Object.values(error)
						.flat()
						.filter((m) => typeof m === "string");
					if (messages.length > 0) {
						description = messages.join(" ");
					}
				}
				showAlert({
					type: "error",
					title: "Error",
					description,
					okButtonText: "Ok",
				});
			});
	}

	return (
		<React.Fragment>
			<MainStructure>
				<div className="center">
					<h2 className="huge-letters is-black">
						New <span className="is-bold">List</span>
					</h2>
					<br />
					<div className="step1-container">
						<Step1
							selected={pedigreeData}
							handleStep1Change={handleStep1Change}
							setIsOpenModels={setIsOpenModels}
						/>
					</div>
					<br />
					<div className="step2-container mb-40">
						<Step2
							handleReportClick={handleReportClick}
							setPedigreeData={setPedigreeData}
							pedigreeData={pedigreeData}
						/>
					</div>
				</div>
				<ModelsModal
					isOpenModels={isOpenModels}
					setIsOpenModels={setIsOpenModels}
				/>
				<SourAlert {...alertProps} />
			</MainStructure>
		</React.Fragment>
	);
}

export default NewList;
